import React from 'react';

import { createDefaultTyrann } from '@apis/common';
import { Layout } from '@components/Layout';
import { createUseQuery } from '@hooks/createUseQuery';
import * as t from 'io-ts';

const user = t.type({
  email: t.number,
});

const userApis = createDefaultTyrann({
  '/user/': {
    get: {
      response: {
        200: user,
      },
    },
  },
});

const useUser = createUseQuery(
  ['/user'],
  () => () => userApis.get('/user/', {}).then((r) => r[200]!),
);

export const TestBadResponse = () => {
  const user = useUser();

  return (
    <Layout title="TestStatusError404" loading={user.isLoading} errors={[user.error]}>
      This should let sentry capture detailed error messages.
    </Layout>
  );
};
